import React from "react";
import { styled } from "../../../../stitches.config";

import { withlazyload } from "../../../HOCs/WithLazyLoad";

@withlazyload({
  height: 500,
  once: true,
  offset: 600
})
export default class YoutubeVideo extends React.Component {

  render() {
    return (
      <Wrapper>
        <IFrame
          title={"Youtube video" + this.props.dataId}
          css={{
            position: "absolute",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%"
          }}
          src={"https://www.youtube.com/embed/" + this.props.dataId}
          frameborder="0"
          allow="autoplay; encrypted-media" allowfullscreen/>
        {this.props.description ?
          (<span className="image-gallery-description">{this.props.description}</span>)
          : null}
      </Wrapper>
    );
  }
}

const Wrapper = styled("div",{
  position: "relative",
  paddingBottom: "56.25%",
  paddingTop: "25px",
  margin: "20px 0",
  "@bp4": {
    minHeight: "474px"
  }
});

const IFrame = styled("iframe",{
  position: "absolute",
  top: "0",
  left: "0",
  width: "100%",
  height: "100%"
})